export interface QueryMap {
  [key: string]: string | number | boolean | (string | number | boolean)[];
}

const prepareSearchParams = (query: QueryMap): string => {
  const params = new URLSearchParams();

  for (const key in query) {
    const value = query[key];
    if (Array.isArray(value)) {
      value.forEach((param) => params.append(key, param as string));
    } else {
      params.append(key, value as string);
    }
  }

  return params.toString();
};

export default prepareSearchParams;
